import { render, staticRenderFns } from "./CardTask.vue?vue&type=template&id=91fb2eac&scoped=true"
import script from "./CardTask.vue?vue&type=script&lang=js"
export * from "./CardTask.vue?vue&type=script&lang=js"
import style0 from "./CardTask.vue?vue&type=style&index=0&id=91fb2eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fb2eac",
  null
  
)

export default component.exports